export default {
  header: 'Vælg menu',
  open_now: 'Åben nu',
};
